var last_fg = null;

module.exports = {
	bg: [
		'#543C2E',
		'#602925',
		'#3A3A37',
		'#4B5150',
		'#575957'
	],
	fg: [
		'linear-gradient(to top, #FA2D17, #FD8C19)',
		'linear-gradient(to top, #ED5B24, #FDD181)',
		'linear-gradient(to top, #87A544, #F6DD7C)',
		'linear-gradient(to top, #5AA3C1, #F6F28B)',
		'linear-gradient(to top, #D06C83, #FFC36C)',
		'linear-gradient(to top, #0060B0, #DBA6A7)',
		'linear-gradient(to top, #283B83, #63A6A7)'
	],
	fill: function() {
		// do not return the same color twice in a row
		var new_fg = choose(module.exports.fg);
		if (new_fg !== last_fg) {
			last_fg = new_fg;
			return new_fg;
		}
		return module.exports.fill();
	},
	background: function() {
		return choose(module.exports.bg);
	}
}

window.fill = module.exports.fill;

function choose(list) {
	return list[Math.floor(Math.random() * list.length)];
}